import React, { useCallback, useEffect, useRef, useState } from 'react';

import { NotificationManager, prepareRequest, StorageManager, useSettings } from '@atlas/core';

export const WithdrawalCodePopup = ({ data, id }) => {
  const frame = useRef(null);
  const [iframeUrl, setIframeUrl] = useState('');
  const { id: correlationId } = data;
  const { lang } = useSettings();
  const token = StorageManager.getItem('tk', '');

  const sendData = useCallback(() => {
    frame?.current?.contentWindow?.postMessage(
      {
        correlationId,
        id,
        info: true,
        lang,
        token,
      },
      '*',
    );
  }, [correlationId, id, token, lang]);

  useEffect(() => {
    prepareRequest({
      method: 'GET',
      url: 'public-retail/retail-service/config/iframe-url',
    })()
      .then(({ url }) => setIframeUrl(url))
      .catch(() => setIframeUrl(''));

    const messageHandler = e => {
      if (e.data.type === 'shakehand') {
        sendData();
      }

      if (e.data.type === 'closeModal') {
        NotificationManager.removeNotification(id);
      }
    };

    window.addEventListener('message', messageHandler);

    return () => window.removeEventListener('message', messageHandler);
  }, [id]);

  if (!iframeUrl) return null;

  return <iframe className="withdrawal-cashdesk" ref={frame} src={iframeUrl} />;
};

export default WithdrawalCodePopup;
